import ShoppingCart from '@/assets/icons/ShoppingCart.svg';
import { NotifyModal } from '@/hooks/useProductPurchasing/NotifyModal';
import { PurchaseAction } from '@/constants';
import type { Product, PurchaseActionType } from '@/types';
import * as Styled from './ProductTile.styled';

interface ProductTileCtaProps {
  handler: () => void;
  isPending: boolean;
  product: Product;
}

const getIsNotify = (purchaseAction: PurchaseActionType) =>
  purchaseAction === PurchaseAction.Notify ||
  purchaseAction === PurchaseAction.None;

const getCtaLabel = (purchaseAction: PurchaseActionType) => {
  if (purchaseAction === PurchaseAction.PreOrder) {
    return 'Pre-order';
  }

  if (purchaseAction === PurchaseAction.BackOrder) {
    return 'Back order';
  }

  return 'Add to cart';
};

export const ProductTileCta = ({
  handler,
  isPending,
  product,
}: ProductTileCtaProps) => {
  if (getIsNotify(product.purchaseAction)) {
    return (
      <NotifyModal
        sku={product.sku ?? ''}
        isCarouselCta={true}
        productName={product.name ?? ''}
      />
    );
  }

  const label = getCtaLabel(product.purchaseAction);

  return (
    <Styled.CtaButton
      $purchaseAction={product.purchaseAction}
      aria-label={`${label}: ${product.name}`}
      handler={handler}
      isPending={isPending}
    >
      <ShoppingCart />
      <span>{label}</span>
    </Styled.CtaButton>
  );
};
